module.exports = __webpack_public_path__ + "media/images/slider_3-31a35739d4d5576d9b5a297436fb094f.png";